import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import axios from 'axios' // 请求发送接收
import VueAxios from 'vue-axios' // vue封装axios
import qs from 'qs' // qs与axios发送json参数有必要关联 中文文档: https://www.jianshu.com/p/0976c9f579ed

import ElementPlus, { ElMessage } from 'element-plus' // elementUI for vue3
import 'element-plus/lib/theme-chalk/index.css' // 加载elementUI样式
import 'dayjs/locale/zh-cn' // 导入中文样式
import locale from 'element-plus/lib/locale/lang/zh-cn' // 引入中文本地化组件

axios.interceptors.response.use( // 响应正常的前提下
  response => {
    console.log('服务器正常响应:', response.status)
    return response
  },
  error => {
    const errorRes = error.response
    if (errorRes) {
      const msgInfo = errorRes.headers['exception-message']
      if (msgInfo) {
        ElMessage(decodeURIComponent(msgInfo))
      } else {
        ElMessage('请求异常, 请检查网络')
      }
    } else {
      ElMessage('请求异常, 请检查网络')
    }
    // 服务器长时间无响应 404
    return error
  }
)

const app = createApp(App)
app.use(store)
  .use(router)
  .use(VueAxios, axios)
  .use(ElementPlus, { locale })
  .mount('#app')

// 设置全局变量, 内部可通过this调用 (出处: https://vue3js.cn/docs/zh/api/application-config.html#globalproperties)
app.config.globalProperties.$qs = qs
app.config.globalProperties.$stringify = (params) => {
  return qs.stringify(params)
}
